import React from 'react'
import {Navigate} from 'react-router-dom'
import FooterNavMildiou from './MEP/footer-nav-mildiou'
import EnteteMildiou from './MEP/enete-milidou'

function PlanDeLutteMenu() {
  const [goToSaisieTrait, setgoToSaisieTrait] = React.useState(false)
  const [goToImpactTrait, setgoToImpactTrait] = React.useState(false)
  const [goToHistoriqueAlerte, setgoToHistoriqueAlerte] = React.useState(false)
  
  function handleSaisieTrait(){
    setgoToSaisieTrait(true)
  }
  function handleImpactTrait(){
    setgoToImpactTrait(true)
  }
  function handleHistoriqueAlerte(){
    setgoToHistoriqueAlerte(true)
  }
  if(goToSaisieTrait) {
    return <Navigate push to={`/diagoriskMildiou/menu-plan-de-lutte/Saisie-Traitement`}/>
  }
  if(goToImpactTrait) {
    return <Navigate push to={`/diagoriskMildiou/menu-plan-de-lutte/Simulation-traitement`}/>
  }
  if(goToHistoriqueAlerte) {
    return <Navigate push to={`/diagoriskMildiou/menu-plan-de-lutte/HistoriqueAlertes`}/>
  }
  return (
    <div>
        <EnteteMildiou titre={'Plan de lutte'}/>
        <FooterNavMildiou/>
        <div className='containerMildiou backgroundPink' style={{ height: '105vh'}}> 
          <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', width:'100%', marginTop:'40px'}}>
            {/* <button className='buttonMenuIntrinsecOADMilidou' onClick={handleSaisieTrait} style={{marginBottom:'40px'}}> 
              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <div className='texteMenuIntrinsecOADMilidou' style={{paddingLeft:'20px'}}>
                  Saisir mon dernier traitement 
                </div>
                <div className='texteMenuIntrinsecOADMilidou' style={{paddingRight:'20px'}}>
                  {'>'}
                </div>
              </div>
            </button> */}
            <button className='buttonMenuIntrinsecOADMilidou' onClick={handleImpactTrait} style={{marginBottom:'40px'}}> 
              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <div className='texteMenuIntrinsecOADMilidou' style={{paddingLeft:'20px'}}>
                  Simuler l'impact de mon traitement 
                </div>
                <div className='texteMenuIntrinsecOADMilidou' style={{paddingRight:'20px'}}>
                  {'>'}
                </div>
              </div>
            </button>
            <button className='buttonMenuIntrinsecOADMilidou' onClick={handleHistoriqueAlerte} style={{marginBottom:'40px'}}> 
              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <div className='texteMenuIntrinsecOADMilidou' style={{paddingLeft:'20px'}}>
                  Historique des alertes 
                </div>
                <div className='texteMenuIntrinsecOADMilidou' style={{paddingRight:'20px'}}>
                  {'>'}
                </div>
              </div>
            </button>
          </div>
        </div>
    </div>
  )
}

export default PlanDeLutteMenu